import {
  GET_PLAN_REQUEST,
  GET_PLAN_SUCCESS,
  GET_PLAN_FAILURE,
  CLEAR_PLAN,
} from "actions/plan";

const initialState = {
  loading: false,
  error: {},
  data: [],
  price_import: 0,
  price_export: 0,
  operation_mode: "",
  operation_description: "",
  operation_information: "",
  dataLoaded: false,
  dataNextDay: [],
};

export default function plan(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_PLAN_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_PLAN_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: payload.data.map((it) => {
          return {
            ...it,
            price_export: it.price_export
              ? it.price_export * -1.0
              : it.price_export,
          };
        }),
        price_export: payload.price_export
          ? payload.price_export * -1.0
          : payload.price_export,
        price_import: payload.price_import,
        operation_mode: payload.operation_mode,
        operation_description: payload.operation_description,
        operation_information: payload.operation_information,
        dataNextDay: payload.data_next_day.map((it) => {
          return {
            ...it,
            price_export: it.price_export
              ? it.price_export * -1.0
              : it.price_export,
          };
        }),
      };
    }
    case GET_PLAN_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    case CLEAR_PLAN: {
      return {
        ...initialState,
      };
    }

    default:
      return state;
  }
}
